import Betslip from './Betslip';

export default Betslip;



// WEBPACK FOOTER //
// ./src/components/Betslip/index.tsx